export const fontSizes = {
    extraSmall: '4px',
    small: '8px',
    semiSmall: '12px',
    medium: '16px',
    large: '24px',
    extraLarge: '32px',
    xExtraLarge: '40px',
    xxExtraLarge: '80px',
}

export const spacingSizes = {
    extraSmall: '4px',
    small: '8px',
    semiSmall: '12px',
    medium: '16px',
    large: '24px',
    extraLarge: '32px',
    xExtraLarge: '40px',
    xxExtraLarge: '80px',
}